import { map } from 'lodash';
import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import Button from '../ReusableComponents/Button/Button';
import Table from '../ReusableComponents/Table/Table';
import TableHead from '../ReusableComponents/Table/TableHead';
import HeaderCell from '../ReusableComponents/Table/HeaderCell';
import HeaderRow from '../ReusableComponents/Table/HeaderRow';
import TableBody from '../ReusableComponents/Table/TableBody';
import LocationRow from './LocationRow';
import styles from './Locations.module.css';
import LocationModal from './LocationModal';
import { Actions, hasPermissionTo } from '../../Lib/Constants/roles.ts';

const headers = [
  'Name',
  'Daily Limit (Units)',
  'Daily Limits (Boxes)',
  'Daily Limit per Vendor (Units)',
  'Time Slot Limit (Boxes)',
  'Min Booking Days',
  'Max Booking Days',
  'Max Vendors Per Slot',
  'Edit',
];

export default function Locations(props) {
  const { locations, createLocation, updateLocation } = props;
  const [openModal, setOpenModal] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);

  const saveLocation = (location) => {
    if (location.id) {
      updateLocation(location.id, location);
    } else {
      createLocation(location);
    }
    setOpenModal(false);
  };

  const perms = useMemo(() => {
    const canAddLocation = hasPermissionTo(
      'delivery-management',
      props.currentUser.role,
      Actions.CREATE,
      'LOCATION',
    );
    const canUpdateLocation = hasPermissionTo(
      'delivery-management',
      props.currentUser.role,
      Actions.UPDATE,
      'LOCATION',
    );
    return {
      canAddLocation,
      canUpdateLocation,
    };
  }, [props.currentUser]);

  return (
    <div className={styles.locationsContainer}>
      <div className={styles.headerContainer}>
        <h3 className={styles.header}>Locations</h3>
        {perms.canAddLocation && (
          <Button
            onClick={() => setOpenModal(!openModal)}
            color="primary"
            variant="outlined"
            small
          >
            Add Location
          </Button>
        )}
      </div>
      <div className={styles.locationsTable}>
        <Table>
          <TableHead>
            <HeaderRow>
              {map(headers, (header) => (
                <HeaderCell key={header} className={styles.locationHeader}>
                  {header}
                </HeaderCell>
              ))}
            </HeaderRow>
          </TableHead>
          <TableBody>
            {map(locations, (location) => (
              <LocationRow
                perms={perms}
                editLocation={() => {
                  setOpenModal(!openModal);
                  setSelectedLocation(location);
                }}
                key={location.id}
                location={location}
              />
            ))}
          </TableBody>
        </Table>
      </div>
      {openModal && (
        <LocationModal
          location={selectedLocation}
          locations={locations}
          saveLocation={saveLocation}
          onClose={() => {
            setOpenModal(!openModal);
            setSelectedLocation(null);
          }}
        />
      )}
    </div>
  );
}

Locations.propTypes = {
  createLocation: PropTypes.func.isRequired,
  locations: PropTypes.shape({}).isRequired,
  updateLocation: PropTypes.func.isRequired,
  currentUser: PropTypes.shape({
    role: PropTypes.string,
  }).isRequired,
};
